
import React from 'react';
import { Users, Target, Award, Globe } from 'lucide-react';

const About: React.FC = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-16 md:py-20 bg-gradient-to-r from-infinity-purple to-infinity-blue text-white">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 md:mb-6">Sobre Infinitywits</h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto">
            Infinity Wits es una empresa dedicada a brindar soluciones integrales en electricidad, energía renovable y digitalización de procesos.</p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            <div className="text-center">
              <Target size={48} className="text-naylamp-yellow mx-auto mb-4 md:mb-6" />
              <h2 className="text-2xl md:text-3xl font-bold text-infinity-black mb-3 md:mb-4">Nuestra Misión</h2>
              <p className="text-gray-600 text-base md:text-lg">
                Proporcionar servicios y productos de alta calidad en energía renovable y digitalización de procesos, para satisfacer las necesidades de nuestros clientes y contribuir a un futuro más sostenible.
              </p>
            </div>
            <div className="text-center">
              <Globe size={48} className="text-infinity-purple mx-auto mb-4 md:mb-6" />
              <h2 className="text-2xl md:text-3xl font-bold text-infinity-black mb-3 md:mb-4">Nuestra Visión</h2>
              <p className="text-gray-600 text-base md:text-lg">
                Ser líderes en la industria de la electricidad y la energía renovable, ofreciendo soluciones innovadoras y sostenibles que transformen la forma en que las personas y las empresas utilizan la energía.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-12 md:py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-infinity-black mb-4">Nuestros Valores</h2>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            <div className="text-center">
              <Award size={40} className="text-naylamp-yellow mx-auto mb-3 md:mb-4" />
              <h3 className="text-lg md:text-xl font-bold text-infinity-black mb-2">Calidad</h3>
              <p className="text-gray-600 text-sm md:text-base">Productos y servicios de la más alta calidad</p>
            </div>
            <div className="text-center">
              <Users size={40} className="text-infinity-purple mx-auto mb-3 md:mb-4" />
              <h3 className="text-lg md:text-xl font-bold text-infinity-black mb-2">Compromiso</h3>
              <p className="text-gray-600 text-sm md:text-base">Dedicados al éxito de nuestros clientes</p>
            </div>
            <div className="text-center">
              <Target size={40} className="text-naylamp-yellow mx-auto mb-3 md:mb-4" />
              <h3 className="text-lg md:text-xl font-bold text-infinity-black mb-2">Innovación</h3>
              <p className="text-gray-600 text-sm md:text-base">Tecnologías avanzadas y soluciones creativas</p>
            </div>
            <div className="text-center">
              <Globe size={40} className="text-infinity-purple mx-auto mb-3 md:mb-4" />
              <h3 className="text-lg md:text-xl font-bold text-infinity-black mb-2">Sostenibilidad</h3>
              <p className="text-gray-600 text-sm md:text-base">Compromiso con el medio ambiente</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;